import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@material-ui/core';

const WarningModal = ({ open, onClose, onSubmit, title, message, loading }) => {

    return (
        <Dialog
            fullWidth={true}
            maxWidth="xs"
            open={open}
            onClose={onClose}
            disableEscapeKeyDown={true}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle
                id="responsive-dialog-title"
                style={{ padding: "12px 24px" }}
                disableTypography
            >
                <Typography className="font-weight-bold" variant="subtitle1" color="textPrimary">
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent style={{ padding: "16px 24px" }}>
                <DialogContentText className='m-0' color="textPrimary">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ padding: "12px 24px" }}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onClose}
                >
                    No
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={onSubmit}
                    disabled={loading === true ? true : false}
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WarningModal;